import { c as _c } from "react/compiler-runtime";
import { openWindowSafely } from '@systemeio/util';
import StudentProgressExportNotificationItem from 'modules/courses/students/components/student-progress-export-notification-item';
import { NotificationTypeEnum } from 'modules/profile/notification-settings/enums/notification-settings-enum';
import SharingNotificationItem from 'modules/share/components/sharing-notification-item';
import { type ActionMenuItemProps } from 'shared/components';
import { RelativeTime } from 'shared/components/relative-time';
import useUser from 'shared/hooks/use-user';
import { getNotificationIcon } from '../constants/notification-icons';
import { useNotificationsActions } from '../hooks/use-notification-actions';
import type { NotificationBaseItemInterface } from '../types/base-notification-interface';
import type { NotificationItemInterface } from '../types/notification-types';
import { NotificationItemView } from './notification-item-view';
export interface BaseNotificationProps {
  notification: NotificationBaseItemInterface;
  actions?: ActionMenuItemProps[];
  className?: string;
  /** Set where the host renders the timestamp itself, such as a dedicated table column. */
  hideTimestamp?: boolean;
}
const BaseNotificationItem = t0 => {
  const $ = _c(17);
  const {
    actions,
    className,
    hideTimestamp,
    notification
  } = t0;
  const {
    user
  } = useUser();
  const {
    getNotificationLink
  } = useNotificationsActions();
  let t1;
  if ($[0] !== getNotificationLink || $[1] !== notification.id) {
    t1 = async () => {
      const safeWindow = openWindowSafely();
      ;
      try {
        const {
          link
        } = await getNotificationLink(notification.id);
        safeWindow.navigate(link);
      } catch (t2) {
        const error = t2;
        safeWindow.close();
        throw error;
      }
    };
    $[0] = getNotificationLink;
    $[1] = notification.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleNotificationClick = t1;
  const t2 = notification.read;
  let t3;
  if ($[3] !== notification) {
    t3 = getNotificationIcon(notification);
    $[3] = notification;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== hideTimestamp || $[6] !== notification.createdAt || $[7] !== user) {
    t4 = !hideTimestamp && user && <RelativeTime time={notification.createdAt} />;
    $[5] = hideTimestamp;
    $[6] = notification.createdAt;
    $[7] = user;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== actions || $[10] !== className || $[11] !== handleNotificationClick || $[12] !== notification.message || $[13] !== notification.read || $[14] !== t3 || $[15] !== t4) {
    t5 = <NotificationItemView className={className} isRead={t2} icon={t3} message={notification.message} description={t4} actions={actions} onClick={handleNotificationClick} />;
    $[9] = actions;
    $[10] = className;
    $[11] = handleNotificationClick;
    $[12] = notification.message;
    $[13] = notification.read;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export interface NotificationItemProps {
  notification: NotificationItemInterface;
  actions?: ActionMenuItemProps[];
  className?: string;
  hideTimestamp?: boolean;
}
export const NotificationItem = t0 => {
  const $ = _c(13);
  const {
    actions,
    className,
    hideTimestamp,
    notification
  } = t0;
  switch (notification.eventType) {
    case NotificationTypeEnum.StudentProgressExport:
      {
        let t1;
        if ($[0] !== actions || $[1] !== className || $[2] !== notification) {
          t1 = <StudentProgressExportNotificationItem notification={notification} actions={actions} className={className} />;
          $[0] = actions;
          $[1] = className;
          $[2] = notification;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case NotificationTypeEnum.SharingStarted:
      {
        let t1;
        if ($[4] !== actions || $[5] !== className || $[6] !== notification) {
          t1 = <SharingNotificationItem notification={notification} actions={actions} className={className} />;
          $[4] = actions;
          $[5] = className;
          $[6] = notification;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    default:
      {
        let t1;
        if ($[8] !== actions || $[9] !== className || $[10] !== hideTimestamp || $[11] !== notification) {
          t1 = <BaseNotificationItem notification={notification} actions={actions} className={className} hideTimestamp={hideTimestamp} />;
          $[8] = actions;
          $[9] = className;
          $[10] = hideTimestamp;
          $[11] = notification;
          $[12] = t1;
        } else {
          t1 = $[12];
        }
        return t1;
      }
  }
};